/**
 * Nomes e opções de país (ISO 3166-1 alfa-2) no painel (#293).
 *
 * A lista de códigos vem da API de países da #313 (GET /public/countries no
 * modal de lead; GET /platform/countries no admin da plataforma) — não há
 * lista própria aqui. O nome é o de Intl.DisplayNames no idioma do painel
 * (mesmo mecanismo do seletor "Preços para" da landing).
 */
export type CountryOption = { value: string; label: string }

const ISO2 = /^[A-Z]{2}$/

/** Nome do país no idioma do painel; código cru se o Intl não souber. */
export function countryName(code: string, lang: string): string {
  try {
    const name = new Intl.DisplayNames([lang], { type: 'region' }).of(code)
    if (name && name !== code) return name
  } catch {
    /* idioma ou código inválido para Intl */
  }
  return code
}

/**
 * Opções do <select> de país: códigos ISO2 válidos, sem repetir, ordenados
 * pelo nome no idioma do painel. `extras` (p.ex. o país do restaurante)
 * entram mesmo que a lista da API não os traga.
 */
export function countryOptions(
  lists: Array<ReadonlyArray<string> | null | undefined>,
  lang: string,
  extras: Array<string | null | undefined> = [],
): CountryOption[] {
  const seen = new Set<string>()
  for (const code of [...lists.flatMap((l) => l ?? []), ...extras]) {
    const c = code?.trim().toUpperCase()
    if (c && ISO2.test(c)) seen.add(c)
  }
  const options = [...seen].map((value) => ({ value, label: countryName(value, lang) }))
  let collator: Intl.Collator
  try {
    collator = new Intl.Collator(lang)
  } catch {
    collator = new Intl.Collator()
  }
  return options.sort((a, b) => collator.compare(a.label, b.label))
}
